import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cities: [],
};

export const citySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    storeCities: (state, action) => {
      state.cities = action.payload;
    },
  },
});

export const { storeCities } = citySlice.actions;

export default citySlice.reducer;
